import _ from 'lodash';

const ContactTypesTestIdsScope = {
  DOMAIN: 'contact-types',
  FORM: 'contact-type-form',
  DRAWER: 'contact-type-drawer',
  SYSTEM_TABLE: 'system-contact-types-table',
  COMPANY_TABLE: 'company-contact-types-table',
  DRIVE_COVERAGE: 'drive-coverage',
};

export const ContactTypesTestIds = {
  // ContactTypesPage
  ADD_BUTTON: `${ContactTypesTestIdsScope.DOMAIN}.add-button`,
  PAGE_TABS: `${ContactTypesTestIdsScope.DOMAIN}.page-tabs`,

  // ContactTypesList
  SEARCH_INPUT: `${ContactTypesTestIdsScope.DOMAIN}.search-input`,
  MAPPING_FILTER_TABS: `${ContactTypesTestIdsScope.DOMAIN}.mapping-filter-tabs`,
  SYSTEM_TABLE: `${ContactTypesTestIdsScope.DOMAIN}.system-table`,
  COMPANY_TABLE: `${ContactTypesTestIdsScope.DOMAIN}.company-table`,
  SYSTEM_TABLE_ROW: `${ContactTypesTestIdsScope.SYSTEM_TABLE}.row-label`,
  COMPANY_TABLE_ROW: `${ContactTypesTestIdsScope.COMPANY_TABLE}.row-label`,
  SYSTEM_LOCK_LABEL: `${ContactTypesTestIdsScope.DOMAIN}.system-lock-label`,
  MAPPING_SOURCE_LABEL: `${ContactTypesTestIdsScope.DOMAIN}.mapping-source-label`,
  STATUS_LABEL: `${ContactTypesTestIdsScope.DOMAIN}.status-label`,

  // RowActionButton
  ROW_ACTION_BUTTON: `${ContactTypesTestIdsScope.DOMAIN}.row-action-button`,
  ROW_ACTION_MENU: `${ContactTypesTestIdsScope.DOMAIN}.row-action-menu`,

  // ContactTypeForm
  FORM_NAME_INPUT: `${ContactTypesTestIdsScope.FORM}.name-input`,

  // ContactTypeDrawer
  DRAWER: `${ContactTypesTestIdsScope.DRAWER}.form-drawer`,
  DRAWER_FORM: `${ContactTypesTestIdsScope.DRAWER}.contact-type-form`,
  DRAWER_NAME_INPUT: `${ContactTypesTestIdsScope.DRAWER}.name-input`,
  DRAWER_KIND_RADIO: `${ContactTypesTestIdsScope.DRAWER}.kind-radio`,
  DRAWER_ACTIVE_SWITCH: `${ContactTypesTestIdsScope.DRAWER}.active-switch`,
  DRAWER_DRIVE_SWITCH: `${ContactTypesTestIdsScope.DRAWER}.drive-switch`,
  DRAWER_PERSON_CODE_SELECT: `${ContactTypesTestIdsScope.DRAWER}.person-code-select`,
  DRAWER_PERSON_CODE_INPUT: `${ContactTypesTestIdsScope.DRAWER}.person-code-input`,
  DRAWER_COMPANY_CODE_SELECT: `${ContactTypesTestIdsScope.DRAWER}.company-code-select`,
  DRAWER_COMPANY_CODE_INPUT: `${ContactTypesTestIdsScope.DRAWER}.company-code-input`,
  DRAWER_CODE_OPTION: `${ContactTypesTestIdsScope.DRAWER}.code-option-label`,
  DRAWER_CODE_REQUIRED_HINT: `${ContactTypesTestIdsScope.DRAWER}.code-required-hint`,
  DRAWER_CODES_UNAVAILABLE_ERROR: `${ContactTypesTestIdsScope.DRAWER}.codes-unavailable-error`,
  DRAWER_RESET_BUTTON: `${ContactTypesTestIdsScope.DRAWER}.reset-mapping-button`,
  DRAWER_SUBMIT_BUTTON: `${ContactTypesTestIdsScope.DRAWER}.submit-button`,
  DRAWER_MAPPING_SOURCE_LABEL: `${ContactTypesTestIdsScope.DRAWER}.mapping-source-label`,

  // DriveCoverage
  COVERAGE_SEARCH_INPUT: `${ContactTypesTestIdsScope.DRIVE_COVERAGE}.search-input`,
  COVERAGE_STATUS_TABS: `${ContactTypesTestIdsScope.DRIVE_COVERAGE}.status-tabs`,
  COVERAGE_TABLE: `${ContactTypesTestIdsScope.DRIVE_COVERAGE}.coverage-table`,
  COVERAGE_RETRY_BUTTON: `${ContactTypesTestIdsScope.DRIVE_COVERAGE}.retry-button`,
  COVERAGE_STATUS_LABEL: `${ContactTypesTestIdsScope.DRIVE_COVERAGE}.status-label`,
  getCoverageCreateTypeButtonId: code =>
    `${ContactTypesTestIdsScope.DRIVE_COVERAGE}.create-type-${_.kebabCase(code)}-button`,
};
